// @ts-nocheck
import React from 'react';
import { Box, Card, Typography } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import { getNameWithoutPrefix } from '../../../utils/resources/MetadataAvatarType';
import { toFormatDate } from '../../../utils/date';
import MetadataAvatarTypePropertiesBatched from '../../avatarAnc/columns/MetadataAvatarTypePropertiesBatched';
import CreationDateField from '../../avatarAnc/columns/CreationDateField';
import ShowLastNoteIcon from '../../showLastNoteIcon/showLastNoteIcon';
import InstallationDateField from '../../avatarPropertyReferenceField/installationDateField';
import InstallationDateAvatarPropertyReferenceField
    from '../../avatarPropertyReferenceField/intallationDateAvatarPropertyReferenceField';
import AvatarNoteReferenceField from '../../avatarNoteReferenceField/avatarNoteReferenceField';
import { MAINTENANCE, SLUDGE_EMPTYING } from '../../../utils/rikutec';
import { alpha, makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import { selectAnc } from '../../../redux/actions/ancs';
import { CRM_COLORS, CRM_RADIUS } from '../../../theme/crmColors';
import { BREAKPOINTS } from '../../../theme/breakpoints';
import { useIsMobile } from '../../../hooks/useIsMobile';

const useStyles = makeStyles(() => ({
    modernAncCard: {
        borderRadius: CRM_RADIUS.card,
        boxShadow: CRM_COLORS.shadow,
        border: `1px solid ${CRM_COLORS.border}`,
        backgroundColor: CRM_COLORS.surface,
        cursor: 'pointer',
        transition: 'box-shadow 0.15s ease',
        '&:hover': {
            boxShadow: CRM_COLORS.shadowHover,
        },
    },
    modernAncCardHeaderCollapsed: {
        padding: '16px 20px',
        borderBottom: 'none',
        backgroundColor: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        [`@media (max-width:${BREAKPOINTS.mobile}px)`]: {
            alignItems: 'flex-start',
            padding: '12px 16px',
            gap: '12px',
        },
    },
    modernAncInfo: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1',
    },
    modernAncTitle: {
        fontSize: '1.0625rem',
        fontWeight: 600,
        letterSpacing: '-0.01em',
        color: CRM_COLORS.secondary,
        fontVariantNumeric: 'tabular-nums',
        marginBottom: '0px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flex: '1',
        minWidth: 0,
        marginRight: '12px',
        flexWrap: 'wrap',
        [`@media (max-width:${BREAKPOINTS.mobile}px)`]: {
            fontSize: '0.95rem',
            marginRight: 0,
        },
    },
    modernAncSubtitle: {
        fontSize: '0.8rem',
        color: CRM_COLORS.text.secondary,
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        marginTop: '2px',
    },
    pipeSeparator: {
        color: CRM_COLORS.borderStrong,
        fontSize: '0.875rem',
        fontWeight: 400,
        margin: '0 4px',
    },
    modernAncHeaderDetails: {
        display: 'flex',
        gap: '12px',
        marginTop: '8px',
        flexWrap: 'wrap',
        [`@media (max-width:${BREAKPOINTS.mobile}px)`]: {
            flexDirection: 'column',
            gap: '6px',
            marginTop: '4px',
        },
    },
    modernAncHeaderDetailItem: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
        minWidth: '100px',
        flex: '1',
        [`@media (max-width:${BREAKPOINTS.mobile}px)`]: {
            minWidth: 0,
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 2fr) minmax(0, 3fr)',
            alignItems: 'baseline',
            gap: '8px',
        },
    },
    modernAncHeaderDetailLabel: {
        fontSize: '0.75rem',
        fontWeight: 400,
        color: CRM_COLORS.text.secondary,
        lineHeight: 1.3,
    },
    modernAncHeaderDetailValue: {
        fontSize: '0.8125rem',
        color: CRM_COLORS.text.primary,
        fontWeight: 500,
        lineHeight: 1.3,
        fontVariantNumeric: 'tabular-nums',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
    },
    modernAncStatus: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '0px',
        flexShrink: 0,
        marginLeft: 'auto',
        [`@media (max-width:${BREAKPOINTS.mobile}px)`]: {
            alignSelf: 'flex-start',
        },
    },
    modernAncCardHeaderWithActions: {
        [`@media (max-width:${BREAKPOINTS.mobile}px)`]: {
            flexDirection: 'column',
            alignItems: 'stretch',
            '& $modernAncStatus': {
                alignSelf: 'stretch',
                marginLeft: 0,
                justifyContent: 'space-between',
                flexWrap: 'wrap',
            },
        },
    },
    modernStatusChip: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 4,
        textAlign: 'right',
    },
    modernStatusPill: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        borderRadius: 999,
        padding: '3px 10px 3px 8px',
        fontSize: '0.78rem',
        fontWeight: 600,
        whiteSpace: 'nowrap',
    },
    modernStatusDot: {
        width: 6,
        height: 6,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
        flexShrink: 0,
    },
    modernStatusDate: {
        fontSize: '0.78rem',
        color: CRM_COLORS.text.secondary,
        fontVariantNumeric: 'tabular-nums',
        whiteSpace: 'nowrap',
    },
    modernStatusActive: CRM_COLORS.status.ok,
    modernStatusWarning: CRM_COLORS.status.wait,
    modernStatusError: CRM_COLORS.status.bad,
}));

const getStatusChip = (status, dateOfTakesPlace, classes) => {
    const statusMap = {
        'MISE EN SERVICE': { type: 'active', label: 'En service' },
        'FIN DE MISE EN SERVICE': { type: 'warning', label: 'Fin de service' },
        'BLOQUÉ QUALITÉ': { type: 'error', label: 'Bloqué qualité' },
        REBUT: { type: 'error', label: 'Rebut' },
        'PRÊTE À LIVRER': { type: 'warning', label: 'Prête à livrer' },
        POSER: { type: 'warning', label: 'À poser' },
    };

    const normalized = (status || '').toString().trim().toUpperCase();
    const statusInfo = statusMap[normalized] || { type: 'warning', label: status };
    const statusClass = `modernStatus${statusInfo.type.charAt(0).toUpperCase() + statusInfo.type.slice(1)}`;

    return (
        <Box className={classes.modernStatusChip}>
            <span className={`${classes.modernStatusPill} ${classes[statusClass]}`}>
                <span className={classes.modernStatusDot} aria-hidden />
                {statusInfo.label}
            </span>
            {dateOfTakesPlace && <span className={classes.modernStatusDate}>{toFormatDate(dateOfTakesPlace)}</span>}
        </Box>
    );
};

// Helper to decide whether to show maintenance/vidange related info
const isNormalState = (status) => {
    const normalStates = ['mise en service', 'fin de mise en service'];
    return normalStates.includes(status?.trim().toLowerCase());
};

// Local DateFieldWrapper (same as used in index.tsx)
const DateFieldWrapper = (props) => {
    const noteIds = props.notes && typeof props.notes === 'object' ? Object.keys(props.notes) : [];
    const noteId = noteIds.length > 0 ? noteIds[0] : null;
    return <>{noteId && props.notes ? toFormatDate(props.notes[noteId].createdAt) : ''}</>;
};

// Props now optionally accept a `record` and will derive all values from it when provided
const CardItem = ({
    id,
    record,
    displayId: displayIdProp,
    metadataId: metadataIdProp,
    statusName: statusNameProp,
    statusDate: statusDateProp,
    typeName: typeNameProp,
    creationDate,
    totalUsefulVolume,
    processingCapacity,
    installationDateNode,
    maintenanceDateNode,
    maintenanceIconNode,
    emptyingDateNode,
    emptyingIconNode,
    showMaintenance = true,
    headerAction,
    children,
}: any) => {
    const classes = useStyles();
    const t = useTranslate();
        const dispatch = useDispatch();
    const isMobile = useIsMobile();

    // Prefer values from `record` when provided, otherwise fallback to explicit props (backward compatible)
    const derivedMetadataIdFromRecord = (() => {
        const mat = record?.metadataAvatarType;
        if (!mat) return undefined;
        if (typeof mat === 'string') return mat;
        return mat.id || mat['@id'];
    })();

    const computedMetadataId = metadataIdProp ?? derivedMetadataIdFromRecord;
    const typeTitleName = typeNameProp ?? record?.metadataAvatarType?.name;
    const statusName = statusNameProp ?? record?.currentNode?.name ?? 'MISE EN SERVICE';
    const statusDate = statusDateProp ?? record?.currentNode?.dateOfTakesPlace;

    const creationDateValue = creationDate ?? record?.creationDate;
    const totalUsefulVolumeValue = totalUsefulVolume ?? record?.totalUsefulVolume;
    const processingCapacityValue = processingCapacity ?? record?.processingCapacity;

    const extractIdFromAny = (value) => {
        if (!value) return undefined;
        if (typeof value === 'string') {
            const parts = value.split('/');
            return parts[parts.length - 1] || value;
        }
        if (typeof value === 'object') {
            return extractIdFromAny(value.id || value['@id']);
        }
        return undefined;
    };

    const idFromRecord = extractIdFromAny(record?.id);
    const displayId =
        displayIdProp ?? record?.alphaId ?? record?.originId ?? `ANC-${extractIdFromAny(id) ?? idFromRecord ?? ''}`;

    const installationDateNodeValue =
        installationDateNode ??
        (record ? (
            <InstallationDateAvatarPropertyReferenceField record={record}>
                <InstallationDateField />
            </InstallationDateAvatarPropertyReferenceField>
        ) : undefined);

    const maintenanceDateNodeValue =
        maintenanceDateNode ??
        (record ? (
            <AvatarNoteReferenceField tags={[MAINTENANCE]} componentIdentification={MAINTENANCE} record={record}>
                <DateFieldWrapper />
            </AvatarNoteReferenceField>
        ) : undefined);

    const maintenanceIconNodeValue =
        maintenanceIconNode ??
        (record ? (
            <AvatarNoteReferenceField tags={[MAINTENANCE]} componentIdentification={MAINTENANCE} record={record}>
                <ShowLastNoteIcon record={record} tag={MAINTENANCE} />
            </AvatarNoteReferenceField>
        ) : undefined);

    const emptyingDateNodeValue =
        emptyingDateNode ??
        (record ? (
            <AvatarNoteReferenceField
                tags={[SLUDGE_EMPTYING]}
                componentIdentification={SLUDGE_EMPTYING}
                record={record}
            >
                <DateFieldWrapper />
            </AvatarNoteReferenceField>
        ) : undefined);

    const emptyingIconNodeValue =
        emptyingIconNode ??
        (record ? (
            <AvatarNoteReferenceField
                tags={[SLUDGE_EMPTYING]}
                componentIdentification={SLUDGE_EMPTYING}
                record={record}
            >
                <ShowLastNoteIcon record={record} tag={SLUDGE_EMPTYING} />
            </AvatarNoteReferenceField>
        ) : undefined);

    const statusChip = getStatusChip(statusName, statusDate, classes);

    return (
        <Card className={classes.modernAncCard} onClick={() => record && dispatch(selectAnc(record))} style={{ cursor: 'pointer' }}>
            <Box
                className={`${classes.modernAncCardHeaderCollapsed} ${
                    headerAction ? classes.modernAncCardHeaderWithActions : ''
                }`}
            >
                <Box className={classes.modernAncInfo}>
                    {isMobile ? (
                        <>
                            <Typography className={classes.modernAncTitle}>
                                {typeTitleName ? getNameWithoutPrefix(typeTitleName) : 'Type non défini'}
                            </Typography>
                            <Typography className={classes.modernAncSubtitle}>
                                N° {displayId || `ANC-${extractIdFromAny(id)}`}
                                {computedMetadataId && (
                                    <>
                                        <span className={classes.pipeSeparator}>·</span>
                                        <MetadataAvatarTypePropertiesBatched
                                            metadataAvatarType={computedMetadataId}
                                            name='productCode'
                                        />
                                    </>
                                )}
                            </Typography>
                        </>
                    ) : (
                        <Typography className={classes.modernAncTitle}>
                            {typeTitleName ? getNameWithoutPrefix(typeTitleName) : 'Type non défini'}
                            <span className={classes.pipeSeparator}>|</span>
                            {displayId || `ANC-${extractIdFromAny(id)}`}
                            <span className={classes.pipeSeparator}>|</span>
                            {computedMetadataId ? (
                                <MetadataAvatarTypePropertiesBatched metadataAvatarType={computedMetadataId} name='productCode' />
                            ) : (
                                'N/A'
                            )}
                        </Typography>
                    )}

                    {/* Additional info for all statuses */}
                    <Box className={classes.modernAncHeaderDetails}>
                        <Box className={classes.modernAncHeaderDetailItem}>
                            <Typography className={classes.modernAncHeaderDetailLabel}>
                                {t('app.objects.info.created')}
                            </Typography>
                            <Typography className={classes.modernAncHeaderDetailValue}>
                                <CreationDateField record={{ creationDate: creationDateValue }} />
                            </Typography>
                        </Box>

                        {/* Specs de producto: ocultos en móvil (no aportan al escaneo rápido). */}
                        {!isMobile && (
                        <>
                        <Box className={classes.modernAncHeaderDetailItem}>
                            <Typography className={classes.modernAncHeaderDetailLabel}>
                                {t('app.ancs.sludgeStorageVolume')}
                            </Typography>
                            <Typography className={classes.modernAncHeaderDetailValue}>
                                {computedMetadataId ? (
                                    <MetadataAvatarTypePropertiesBatched
                                        metadataAvatarType={computedMetadataId}
                                        name='sludgeStorageVolume'
                                    />
                                ) : (
                                    'N/A'
                                )}
                            </Typography>
                        </Box>

                        <Box className={classes.modernAncHeaderDetailItem}>
                            <Typography className={classes.modernAncHeaderDetailLabel}>Volume totale utile</Typography>
                            <Typography className={classes.modernAncHeaderDetailValue}>
                                {(() => {
                                    if (!computedMetadataId) return 'N/A';

                                    if (totalUsefulVolumeValue) {
                                        return totalUsefulVolumeValue;
                                    }

                                    return (
                                        <MetadataAvatarTypePropertiesBatched
                                            metadataAvatarType={computedMetadataId}
                                            name='totalUsefulVolume'
                                        />
                                    );
                                })()}
                            </Typography>
                        </Box>

                        <Box className={classes.modernAncHeaderDetailItem}>
                            <Typography className={classes.modernAncHeaderDetailLabel}>Modèle</Typography>
                            <Typography className={classes.modernAncHeaderDetailValue}>
                                {computedMetadataId ? (
                                    <MetadataAvatarTypePropertiesBatched
                                        metadataAvatarType={computedMetadataId}
                                        name='model'
                                    />
                                ) : (
                                    'N/A'
                                )}
                            </Typography>
                        </Box>

                        <Box className={classes.modernAncHeaderDetailItem}>
                            <Typography className={classes.modernAncHeaderDetailLabel}>
                                Capacité de traitement
                            </Typography>
                            <Typography className={classes.modernAncHeaderDetailValue}>
                                {(() => {
                                    if (!computedMetadataId) return 'N/A';

                                    if (processingCapacityValue) {
                                        return processingCapacityValue;
                                    }

                                    return (
                                        <MetadataAvatarTypePropertiesBatched
                                            metadataAvatarType={computedMetadataId}
                                            name='processingCapacity'
                                        />
                                    );
                                })()}
                            </Typography>
                        </Box>
                        </>
                        )}

                        {/* Show maintenance and vidange only for Mise en service or Fin de mise en service */}
                        {showMaintenance && isNormalState(statusName) && (
                            <>
                                {/* Show installation date right before maintenance */}
                                <Box className={classes.modernAncHeaderDetailItem}>
                                    <Typography className={classes.modernAncHeaderDetailLabel}>
                                        Date d'installation
                                    </Typography>
                                    <Typography className={classes.modernAncHeaderDetailValue}>
                                        {installationDateNodeValue || 'N/A'}
                                    </Typography>
                                </Box>

                                <Box className={classes.modernAncHeaderDetailItem}>
                                    <Typography className={classes.modernAncHeaderDetailLabel}>Maintenance</Typography>
                                    <Box className={classes.modernAncHeaderDetailValue}>
                                        {maintenanceDateNodeValue}
                                        {maintenanceIconNodeValue}
                                    </Box>
                                </Box>

                                <Box className={classes.modernAncHeaderDetailItem}>
                                    <Typography className={classes.modernAncHeaderDetailLabel}>Vidange</Typography>
                                    <Box className={classes.modernAncHeaderDetailValue}>
                                        {emptyingDateNodeValue}
                                        {emptyingIconNodeValue}
                                    </Box>
                                </Box>
                            </>
                        )}
                    </Box>
                </Box>

                <Box className={classes.modernAncStatus}>
                    {statusChip}
                    {headerAction}
                </Box>
            </Box>
            {children}
        </Card>
    );
};

export default CardItem;
